export enum ComparisonOperator {
  GREATER = 'GREATER',
  SMALLER = 'SMALLER',
}
